var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PRIORITY",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25.4mm",
    height: "25.4mm",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.66,13.93L58.07.34c-.22-.22-.51-.34-.81-.34H6.35C2.85,0,0,2.85,0,6.35v59.29c0,3.5,2.85,6.35,6.35,6.35h59.29c3.5,0,6.35-2.85,6.35-6.35V14.74c0-.31-.12-.6-.34-.81ZM18.59,2.3h34.82v15.22c0,2.65-2.52,4.81-5.61,4.81h-23.6c-3.09,0-5.61-2.16-5.61-4.81V2.3Zm41.23,67.4H12.18v-26.95h47.63v26.95Zm9.88-4.05c0,2.24-1.82,4.05-4.05,4.05h-3.53v-28.1c0-.64-.51-1.15-1.15-1.15H11.03c-.64,0-1.15.51-1.15,1.15v28.1h-3.53c-2.24,0-4.05-1.82-4.05-4.05V6.35c0-2.24,1.82-4.05,4.05-4.05h9.93v15.22c0,3.92,3.55,7.11,7.91,7.11h23.6c4.36,0,7.91-3.19,7.91-7.11V2.3h1.07l12.92,12.92v50.43Zm-26.5-46.13h4.95c.64,0,1.15-.51,1.15-1.15V6.27c0-.64-.51-1.15-1.15-1.15h-4.95c-.64,0-1.15.51-1.15,1.15v12.09c0,.64.51,1.15,1.15,1.15Zm1.15-12.09h2.65v9.79h-2.65V7.42Z",
    fill: "#1d1d1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.1449d3ecfc94e0edef774f493c724a8b.svg";
export { ForwardRef as ReactComponent };